import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "./locales/it.json";
import en from "./locales/en.json";

export const SUPPORTED_LOCALES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

export const FALLBACK_LOCALE = "it";
export const STORAGE_KEY = "ccx_locale";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
    },
    fallbackLng: FALLBACK_LOCALE,
    supportedLngs: SUPPORTED_LOCALES.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      // Use the explicit user choice first; never auto-detect on first visit
      // (we want Italian by default for hospitality use case).
      order: ["localStorage"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

// Force default to Italian on first load if nothing is stored.
if (typeof window !== "undefined") {
  try {
    if (!window.localStorage.getItem(STORAGE_KEY)) {
      i18n.changeLanguage(FALLBACK_LOCALE);
    }
  } catch (e) {
    // ignore
  }
}

// Map UI locale to a BCP-47 locale used by Intl APIs (date/currency formatting).
export function intlLocale(code) {
  switch (code) {
    case "it":
      return "it-IT";
    case "en":
      return "en-GB";
    default:
      return "it-IT";
  }
}

export default i18n;
